import Image from 'next/image';

import BgShapeImage from '@/assets/CNC-rfq/bg-shape.png';
import PainSectionImage from '@/assets/CNC-rfq/pain-section.png';
import Icon from '@/components/Icon';
import Text from '@/components/Text';

const problems = [
  {
    icon: 'material-symbols:update',
    title: 'Hours of manual work',
    description:
      "Every RFQ requires a lot of engineering time before you even know if you'll win the job.",
  },
  {
    icon: 'material-symbols:list-alt-outline',
    title: 'Inconsistent estimates',
    description: 'Different estimators can price the same part differently.',
  },
  {
    icon: 'material-symbols:trending-down',
    title: 'Slow response loses orders',
    description:
      "While you're calculating all the costs, the customer may already be getting another quote.",
  },
];

const CncRfqProblems = () => {
  return (
    <div className="flex w-full flex-col gap-11">
      <div className="flex flex-col items-center gap-5 text-center">
        <Text
          variant="display-4"
          className="z-[5] max-w-3xl text-center text-neutral-0"
        >
          Quoting shouldn&apos;t take longer than machining the part
        </Text>
        <Text className="md:!text-md z-[5] max-w-[500px] text-center text-jb-neutral-600 lg:!text-xl">
          Traditional CNC quoting is slow, manual and inconsistent, costing you
          time and sales.
        </Text>
      </div>
      <div className="relative flex flex-col gap-[60px] overflow-hidden md:flex-row md:items-stretch">
        <Image
          src={BgShapeImage}
          alt="gradient background shape"
          className="pointer-events-none absolute left-1/2 top-1/2 h-auto w-[190%] max-w-none -translate-x-1/2 -translate-y-1/2 opacity-80 sm:w-[165%] md:w-[145%] lg:w-[105%]"
        />
        <div className="flex max-w-[600px] flex-col gap-5 md:w-1/2">
          {problems.map(({ icon, title, description }) => (
            <div
              key={title}
              className="flex flex-col gap-6 rounded-xl border border-neutral-0/[55%] bg-buttonCNC/[10%] p-6 backdrop-blur-sm"
            >
              <div className="flex items-center gap-5">
                <div className="size-11 flex shrink-0 items-center justify-center rounded-lg bg-iconsCNC/5 p-[10px]">
                  <Icon icon={icon} className="text-2xl text-jb-primary-400" />
                </div>
                <Text variant="h4" className="font-semibold text-neutral-0">
                  {title}
                </Text>
              </div>
              <Text className="text-jb-neutral-600">{description}</Text>
            </div>
          ))}
        </div>
        <div className="relative min-h-[280px] flex-1 overflow-hidden rounded-xl md:w-1/2">
          <Image src={PainSectionImage} alt="" fill className="object-cover" />
        </div>
      </div>
    </div>
  );
};

export default CncRfqProblems;
